export default "__VITE_ASSET__0dfdb436__"